import { render, staticRenderFns } from "./ListCredenciamentoPJ.vue?vue&type=template&id=198c14ee"
import script from "./ListCredenciamentoPJ.vue?vue&type=script&lang=js"
export * from "./ListCredenciamentoPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports